import './partnersSlider.less';

const PartnersSlider = (selector) => {
	let sliderContainer = document.querySelector(selector);
	if (sliderContainer) {
		let slider = $(selector);
		
		slider.owlCarousel({
			loop: true,
			margin: 0,
			mouseDrag: true,
			dots: false,
			items: 5,
			nav: false,
			autoplay: true,
			autoplayTimeout: 3000,
			responsive: {
				0: {
					items: 2,
				},
				// breakpoint from 480 up
				480: {
					items: 3,
				},
				// breakpoint from 768 up
				768: {
					items: 4,
				},
				// breakpoint from 1024 up
				1024: {
					items: 5,
				}
			}
		});
	}
};
const partnersSlider = new PartnersSlider('#js-partnersSlider');

export {partnersSlider};


// WEBPACK FOOTER //
// ./components/partnersSlider/partnersSlider.js